// import Redux's built in method for combining reducers
import { combineReducers } from "redux";

// Import individual reducers
import authReducer from "./authReducer";
import subMenuReducer from "./subMenuReducer";
import modalReducer from "./modalReducer";
import roleReducer from "./roleReducer";
import userReducer from "./userReducer";

import accessRequestReducer from "./requestAccessReducer.js";
import accessApprovalRequestsReducer from "./accessApprovalRequestsReducer.js";
import membershipApplicationReducer from "./membershipApplicationReducer.js";
import membershipRequestReducer from "./membershipRequestReducer.js";
import membershipTiersReducer from "./membershipTiersReducer.js";
import membersReducer from "./membersReducer.js";
import paymentReducer from "./paymentReducer.js";

import requestReducer from "./requestReducer";
import paymentRequestReducer from "./paymentRequestReducer";
import executiveRequestReducer from "./executiveRequestReducer";
import paymentProjectReducer from "./paymentProjectReducer";
import paymentPurposeReducer from "./paymentPurposeReducer";
import dailyRateReducer from "./dailyRateReducer";
import loanRequestReducer from "./loanRequestReducer.js";
import salaryAdvanceRequestReducer from "./salaryAdvanceRequestReducer";
import rolePermissionsReducer from "./rolePermissionsReducer";
import workflowReducer from "./workflowReducer";
import workflowRouteReducer from "./workflowRouteReducer";
import departmentReducer from "./departmentReducer";
import userGuideReducer from "./userGuideReducer";
import trackReducer from "./trackReducer";
import dashboardReducer from "./dashboardReducer";

// Combine all reducers
// Create a constant named rootReducer and assign it the combineReducers method
const rootReducer = combineReducers({
  // set reducer properties and assign the corresponding reducer as its value
  auth: authReducer,
  subMenu: subMenuReducer,
  modal: modalReducer,
  roles: roleReducer,
  rolePermissions: rolePermissionsReducer,
  departments: departmentReducer,
  users: userReducer,
  accessRequests: accessRequestReducer,
  accessApprovalRequests: accessApprovalRequestsReducer,
  membershipApplication: membershipApplicationReducer,
  membershipRequests: membershipRequestReducer,
  membershipTiers: membershipTiersReducer,
  members: membersReducer,
  payments: paymentReducer,
  requests: requestReducer,
  paymentRequest: paymentRequestReducer,
  executiveRequest: executiveRequestReducer,
  paymentProjects: paymentProjectReducer,
  paymentPurposes: paymentPurposeReducer,
  loanRequests: loanRequestReducer,
  salaryAdvance: salaryAdvanceRequestReducer,
  workflows: workflowReducer,
  workflowRoutes: workflowRouteReducer,
  userGuide: userGuideReducer,
  track: trackReducer,
  dailyRates: dailyRateReducer,
  dashboard: dashboardReducer,
});

export default rootReducer;

// Built and maintained by Jerry Tiehn and Toney
